// Single source of truth for the admin console sections. Both the sidebar Nav
// and the home dashboard cards derive from this, so they can't drift out of sync.
export interface NavItem {
  href: string;
  label: string;
  /** One-line description shown on the home dashboard cards. */
  desc: string;
}

export const NAV: NavItem[] = [
  { href: "/pipeline", label: "Pipeline", desc: "Ingestion schedules, queues, and DLQ retry." },
  { href: "/logs", label: "Logs", desc: "CloudWatch + Sentry logs." },
  { href: "/records", label: "Records", desc: "Places, events, and correction requests." },
  { href: "/review", label: "Review", desc: "Quarantined events awaiting publish, reject, or merge." },
  { href: "/organizers", label: "Organizers", desc: "Companies, performers, individuals." },
  { href: "/entity-roles", label: "Roles", desc: "Who owns/edits which venue or organizer." },
  { href: "/entity-claim-approvals", label: "Claims", desc: "Approve or reject ownership claims." },
  { href: "/content-moderation", label: "Moderation", desc: "AI moderation decision log." },
  { href: "/published-content", label: "Content", desc: "Take down posts, reviews, photos, Q&A." },
  { href: "/promotions", label: "Promotions", desc: "Review and activate paid boosts & pushes." },
  { href: "/users", label: "Users", desc: "Search, inspect, and manage users." },
  { href: "/ai-models", label: "AI / Models", desc: "Model registry and ranking config." },
  { href: "/system-health", label: "System Health", desc: "DB, edge keys, webhooks, and scheduled jobs." },
];
